import axios from "axios"
import URITemplate from "urijs/src/URITemplate"
import { urls } from "utils-lib/builds"
import {
  GET_FALLBACK_MESSAGE_SERVLET_PENDING,
  GET_FALLBACK_MESSAGE_SERVLET_FAILED,
  GET_FALLBACK_MESSAGE_SERVLET_FULFILLED,
} from "constants-lib/actionTypes"

export const pendingAC = () => ({
  type: GET_FALLBACK_MESSAGE_SERVLET_PENDING,
})

export const failedAC = (data) => ({
  type: GET_FALLBACK_MESSAGE_SERVLET_FAILED,
  payload: data,
})

export const fulfilledAC = (data) => ({
  type: GET_FALLBACK_MESSAGE_SERVLET_FULFILLED,
  payload: data,
})

export const getServletFallbackMessage = () => (dispatch, getState) => {
  const { siteLanguage } = getState()
  const locale = siteLanguage?.language || ""
  const api = `FALLBACK_MESSAGE_SERVLET`
  const template = URITemplate(urls.url[api])

  const preURL = template.expand({
    locale: locale.replace("_", "-"),
  })
  const url = preURL
  const config = {
    url,
    method: `get`,
  }

  dispatch(pendingAC(locale))

  return axios(config)
    .then((response) => {
      const formattedResponse =
        response?.data?.data?.rightChannelingFallbackMessageList?.items?.[0]

      dispatch(fulfilledAC(formattedResponse))
      return formattedResponse
    })
    .catch((error) => {
      dispatch(failedAC(error?.response?.status))
      return error
    })
}
